import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";

@TypeManagerDecorator("s25-ng-se-config")
@Component({
    selector: "s25-ng-se-config",
    template: `
        <div class="c-padding--double">
            <h1>Student Engagement Configuration</h1>
            <p>General configuration settings for Student Engagement will be available here.</p>
            <p>This includes display preferences, defaults, and other non-security related settings.</p>
        </div>
    `,
    styles: `
        :host {
            display: block;
        }
    `,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeConfigComponent {}
